import { render, staticRenderFns } from "./ConceptBooth.vue?vue&type=template&id=36bccf51&scoped=true"
import script from "./ConceptBooth.vue?vue&type=script&lang=js"
export * from "./ConceptBooth.vue?vue&type=script&lang=js"
import style0 from "./ConceptBooth.vue?vue&type=style&index=0&id=36bccf51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bccf51",
  null
  
)

export default component.exports